import { getCountriesByIso2 } from '../../@data-loaders/get-countries-by-iso2';
import type { Field } from '../../shared/interfaces';

export const country: Field = {
    feedback: false,
    async mutate(element, elements: any, publicConfig) {
        const countriesByIso2 = await getCountriesByIso2();
        const allowedCountries = Object.entries(countriesByIso2).filter(([iso2]) => {
            return typeof publicConfig.allowedCountries === `undefined` || publicConfig.allowedCountries.includes(iso2);
        });

        const countrySelect = element.input as HTMLSelectElement;
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        let optionSelected = false;

        allowedCountries.forEach(([iso2, countryInfo]) => {
            const option = document.createElement(`option`);
            option.label = `${countryInfo.name} (${countryInfo.native})`;
            option.value = iso2;

            if (!optionSelected) {
                const matchesTimeZone = countryInfo.timeZones.find((countryTimeZone: string) => {
                    return countryTimeZone === userTimeZone;
                });

                if (matchesTimeZone) {
                    optionSelected = true;
                    option.selected = true;
                }
            }

            countrySelect.options.add(option);
        });

        const regionSelect: HTMLSelectElement | undefined = elements.region.input;
        if (!regionSelect) {
            return;
        }

        const selectRegion = (countryISO2: string) => {
            for (let i = regionSelect.options.length - 1; i >= 0; --i) {
                regionSelect.remove(i);
            }

            const countryInfo = countriesByIso2[countryISO2];

            if (countryInfo?.states.length) {
                regionSelect.removeAttribute(`disabled`);
                regionSelect.classList.remove(`opacity-50`, `appearance-none`);
                countryInfo.states.forEach((state: any) => {
                    const option = document.createElement(`option`);
                    option.label = `${state.name}`;
                    option.value = state.code;
                    regionSelect.options.add(option);
                });
            } else {
                regionSelect.setAttribute(`disabled`, `disabled`);
                regionSelect.classList.add(`opacity-50`, `appearance-none`);
                regionSelect.innerHTML = `<option></option>`;
            }
        };

        selectRegion(countrySelect.value);

        countrySelect.onchange = (event: any) => {
            selectRegion(event.target.value);
        };
    },
};
